"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subheading = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

var _excluded = ["muted"];
var StyledSubheading = /*#__PURE__*/(0, _theming.styled)('span', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['muted'].includes(prop);
  },
  target: "e1auc5zz0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['muted'].includes(prop);
  },
  target: "e1auc5zz0",
  label: "StyledSubheading"
})("font-size:", _styles.typography.size.s2 - 1, "px;font-weight:", _styles.typography.weight.extrabold, ";letter-spacing:0.35em;text-transform:uppercase;", function (props) {
  return props.muted && "\n    color: ".concat(_styles.color.dark, ";\n    display: block;\n    line-height: ").concat(_styles.typography.size.m1, "px;\n    margin-bottom: 12px;\n  ");
}, ";");

var Subheading = function Subheading(_ref) {
  var _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledSubheading, (0, _extends2["default"])({
    muted: muted
  }, props));
};

exports.Subheading = Subheading;